module.exports = __webpack_public_path__ + "images/80b2290210c88073706736484956f42c.jpg";